import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { departmentDashboard } from '../../actions/constant';
import departmentDashboardService from '../../../services/departmentDashboard/getDepartmentDashboardCount';
const {
  GET_DEPARTMENT_PTO_FAILURE,
  GET_DEPARTMENT_PTO_REQUEST,
  GET_DEPARTMENT_PTO_SUCCESS,
  GET_DEPARTMENT_PTO_LOADING,
} = departmentDashboard;

function* getDepartmentPTO(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_DEPARTMENT_PTO_LOADING });
    const response = yield call(departmentDashboardService.getDepartmentPTORequest, payload);
    if (response?.status === 200) {
      yield put({ type: GET_DEPARTMENT_PTO_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DEPARTMENT_PTO_FAILURE, payload: error });
  }
}

function* getDepartmentPTOSaga() {
  yield takeEvery(GET_DEPARTMENT_PTO_REQUEST, getDepartmentPTO);
}

export default getDepartmentPTOSaga;
